import axios from "axios";

const URL = "https://gateway.hyundaicolombia.co/";

export const lastNewsforCategories = async () => {
  return await axios.get(URL + "news/categories/all");
};

export const lastNewsforCategoriesOne = async (category: any) => {
  return await axios.post(URL + `news/categories/one`, {category});
};

export const NewsAll = async () => {
  return await axios.get(URL + "news/all");
};

export const NewsOne = async (category: any, slug: any) => {
  return await axios.post(URL + `news/one`, { category, slug });
};

export const NewsOneForDate = async () => {
  return await axios.get(
    `${URL}news/one/date`
  );
};
